export default "__VITE_ASSET__BzTuCuSn__"